module.exports = __webpack_public_path__ + "img/oc.39a27b6c.svg";